import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DotCMSBasicContentlet } from '@dotcms/types';
import { getUVEState } from '@dotcms/uve';

@Component({
  selector: 'custom-dot-cms-uve-fallback',
  templateUrl: './dot-cms-uve-fallback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class DotCmsUveFallbackComponent {
  contentlet = input.required<DotCMSBasicContentlet>();
  // blockEditorContent: CustomDotCmsContentlet;
  //isProductionMode: boolean = PRODUCTION_MODE;
  isEditMode = !!getUVEState();
}
